import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { DxTooltipComponent } from 'devextreme-angular/ui/tooltip';
import ArrayStore from 'devextreme/data/array_store';
import CustomStore from 'devextreme/data/custom_store';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { compact, identity, isNil, omitBy, pickBy, set } from 'lodash-es';
import isEmpty from 'lodash-es/isEmpty';
import mapKeys from 'lodash-es/mapKeys';
import moment, { utc } from 'moment/moment';
import { BehaviorSubject, combineLatest, defer, from, iif, Observable, of } from 'rxjs';
import {
  catchError,
  concatAll,
  concatMap,
  filter,
  finalize,
  map,
  mergeMap,
  startWith,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { oc } from 'ts-optchain';
import {
  DxCellEvent,
  DxCellPreparedEvent,
  DxContextMenuPreparingEvent,
  DxSavedEvent,
  DxSavingEvent,
  DxToolbarPreparingEvent,
} from '../../../../../core/dx.types';
import { hAll, hasAmbTrips, hasBlsTrips, isAlpha } from '../../../../../shared/classes/utils/utils';
import { CommonService } from '../../../../../shared/modules/my-common/services/common.service';
import { ConfigService } from '../../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../../shared/modules/my-common/services/datasource.service';
import { PusherService } from '../../../../../shared/modules/my-common/services/pusher.service';
import { StateStoreService } from '../../../../../shared/modules/my-common/services/state-store.service';
import { ABaseComponent } from '../../../../../shared/modules/ui/components/abstract/a-base.component';
import { DlgSelectSignatureComponent } from '../../../../../shared/modules/ui/components/dlg-select-signature/dlg-select-signature.component';
import { PushNotificationsService } from '../../../../../shared/modules/ui/services/push-notifications.service';
import { UiService } from '../../../../../shared/modules/ui/services/ui.service';
import {
  Employee,
  EmployeeApi,
  LoggerService,
  Signature,
  SignatureApi,
  SignatureConsUniqImgView,
  SignatureView,
  SignatureViewApi,
  Vehicle,
  VehicleApi,
} from '../../../../../shared/sdk';
import { DlgEditServiceTypeComponent } from '../../../../billing/dialogs/dlg-edit-service-type/dlg-edit-service-type.component';
import { DlgEditTimesComponent } from '../../../../billing/dialogs/dlg-edit-times/dlg-edit-times.component';
import { DlgEditUnitsComponent } from '../../../../billing/dialogs/dlg-edit-units/dlg-edit-units.component';
import { DIRECTION_MARKERS, SERVICE_TYPE } from '../../../../trip-manifest/classes/enums';
import { DlgSelectDriverComponent } from '../../../../trip-manifest/dialogs/dlg-select-driver/dlg-select-driver.component';
import { DlgSelectVehicleComponent } from '../../../../trip-manifest/dialogs/dlg-select-vehicle/dlg-select-vehicle.component';
import { ValidationService } from '../../../services/helper.service';
import { SVObject, TDsItem } from '../types';

@Component({
  selector: 'app-service-validation-v2',
  templateUrl: './service-validation-v2.component.html',
  styleUrls: ['./service-validation-v2.component.scss'],
  providers: [ValidationService],
})
export class ServiceValidationV2Component extends ABaseComponent implements OnInit {
  dso: DataSource | DataSourceOptions | any[];

  changes: any[] = [];
  editRowKey?: number = null;

  isBiller$: Observable<boolean>;
  $filterEvent$: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  facilityDso: DataSourceOptions = [];
  consumerDso: DataSourceOptions = [];
  employeeDso: DataSourceOptions = [];
  vehicleDso: DataSourceOptions = [];

  consumerSubDso$: Observable<DataSourceOptions> = of([]);
  employeeSubDso$: Observable<DataSourceOptions> = of([]);
  vehicleSubDso$: Observable<DataSourceOptions> = of([]);

  serviceTypes = [
    ...Object.values(SERVICE_TYPE),
    ...(hasAmbTrips() ? ['AMB_TRIP'] : []),
    ...(hasBlsTrips() ? ['BLS_TRIP'] : []),
  ];
  directionMarkers = [
    ...Object.values(DIRECTION_MARKERS),
    ...(hasAmbTrips() ? ['TO_AMB', 'FROM_AMB'] : []),
    ...(hasBlsTrips() ? ['TO_BLS', 'FROM_BLS'] : []),
  ];
  validationStates = [
    { v: 'PENDING', t: 'Not Validated' },
    { v: 'VALID', t: 'Valid' },
    { v: 'INVALID', t: 'Invalid' },
    { v: 'ISSUES', t: 'Issues' },

    { v: 'FULL_AUTO_VALIDATED', t: 'Full Auto Validated' },
    { v: 'PARTIAL_AUTO_VALIDATED', t: 'Partial Auto Validated' },
  ];

  //region filter

  selectedFromValue?: Date = moment().toDate();
  selectedToValue?: Date = moment().toDate();

  facilityId?: number;
  driverId?: number;
  clientId?: number;

  // tripDayClosed?: boolean;
  dayServiceMarker?: string;
  validationState?: string;
  hasMissingData?: boolean;
  possibleIssues?: boolean;

  mci?: string;
  serviceType?: string;
  directionMarker?: string;
  hasTrip?: boolean;

  withDriverSigns = false;
  withEscortSigns = false;

  minPuDoDiff = 5;
  maxPuDoDiff = 65;
  maxPuLgtcPuDiff = 60;

  //endregion

  tripDsoMap: Map<number, SVObject['_trips']> = new Map();

  private vehicleDsMap: {
    [id: string]: {
      fullInstance?: any;
    };
  } = {};

  private driverDsMap: {
    [id: string]: {
      fullInstance?: any;
    };
  } = {};

  private dataCollection: string;

  //
  currentTooltipTemplate: 'arrPuDoTimes' | 'trips' | 'trip';
  isTooltipVisible = false;
  tooltipTargetSelector: any = null;
  tooltipData: any;
  toolTipDataMap: { [columnAndId: string]: Observable<string> } = {};

  currentPopoverTemplate: 'mealImg';
  isPopoverVisible = false;
  popoverTargetSelector: any = null;
  popoverData: any;

  grid_stateStoring: any;

  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  // @ViewChild('from', { static: true }) fromDateBox: DxDateBoxComponent;
  // @ViewChild('to', { static: true }) toDateBox: DxDateBoxComponent;

  constructor(
    protected logger: LoggerService,
    private router: Router,
    private ui: UiService,
    private common: CommonService,
    public config: ConfigService,
    private dss: DataSourceService,
    private sss: StateStoreService,
    private pusher: PusherService,
    private notification: PushNotificationsService,
    @Inject(HttpClient) private http: HttpClient,
    private dialog: MatDialog,
    // private gridHelper: GridHelperService,
    private sapi: SignatureApi,
    private svapi: SignatureViewApi,
    public service: ValidationService,
  ) {
    super(logger);

    this.grid_stateStoring = this.sss.buildOptions(
      '55434949-2830-4c09-ad10-e4f3f54a9d6d',
      1000,
      'local',
      this.sss.resetState,
    );

    this.dso = this.service.buildEmptyDataSource();
    this.facilityDso = this.service.buildFacilityDataSource();
    this.consumerDso = this.service.buildConsumerDataSource(this.facilityId);
    this.employeeDso = this.service.buildEmployeeDataSource(this.facilityId);
    this.vehicleDso = this.service.buildVehicleDataSource();
  }

  ngOnInit() {
    super.ngOnInit();

    this.isBiller$ = this.config.hasAnyRole$(['SU', 'BILLER']);

    this.$filterEvent$
      .pipe(
        filter(arg => arg),
        tap(() => {
          this.grid.instance.beginCustomLoading('Filtering...');

          this.grid.instance.clearFilter();
          this.grid.instance.clearSelection();
          // await this.grid.instance.deselectAll();

          const curState = { ...this.grid.instance.state(), ...this.sss.resetState };
          // console.log('curState', curState);
          this.grid.instance.state(curState);
        }),
        switchMap(() =>
          this.buildDataSource().pipe(
            startWith(this.service.buildEmptyDataSource()),
            catchError(err => {
              notify(err.message, 'error', 10_000);
              return of(this.service.buildEmptyDataSource());
            }),
            tap(dso => {
              this.dso = dso;
              this.employeeSubDso$ = this.service.buildEmployeeSubDataSource$();
              this.consumerSubDso$ = this.service.buildConsumerSubDataSource$();
              this.vehicleSubDso$ = this.service.buildVehicleSubDataSource$();
            }),
            finalize(() => {
              this.grid.instance.endCustomLoading();
            }),
          ),
        ),

        takeUntil(this.$onDestroy$),
      )
      .subscribe();
  }

  // region data sources

  private buildDataSource() {
    return of(true).pipe(
      map(() => {
        const fromIncl = this.selectedFromValue;
        const toExcl = this.selectedToValue;

        const fromMoment = fromIncl && moment(fromIncl);
        const toMoment = toExcl && moment(toExcl).add(1, 'days');

        if (!fromMoment || !toMoment) {
          throw new Error('Period should be defined');
        }

        if (toMoment.diff(fromMoment, 'months') > 1) {
          throw new Error('Period should be less or equal to 1 month');
        }
        const strFrom = fromMoment && fromMoment.format('YYYY-MM-DD');
        const strTo = toMoment && toMoment.format('YYYY-MM-DD');

        return {
          fromIncl: strFrom,
          toExcl: strTo,

          mci: this.mci,
          // mco: this.mco,
          // broker: this.broker,

          // tripDayClosed: this.tripDayClosed,
          dayServiceMarker: this.dayServiceMarker,
          validationState: this.validationState,
          serviceType: this.serviceType,
          directionMarker: this.directionMarker,
          hasTrip: this.hasTrip,
          // hasClaim: this.hasClaim,

          hasMissingData: this.hasMissingData,
          possibleIssues: this.possibleIssues,

          facilityIds: this.facilityId ? [this.facilityId] : [],
          driverIds: this.driverId ? [this.driverId] : [],
          clientIds: this.clientId ? [this.clientId] : [],

          minPuDoDiff: this.minPuDoDiff,
          maxPuDoDiff: this.maxPuDoDiff,
          maxPuLgtcPuDiff: this.maxPuLgtcPuDiff,

          withDriverSigns: this.withDriverSigns,
          withEscortSigns: this.withEscortSigns,
        };
      }),

      switchMap(_filter => this.pusher.rpc('GET_SERVICES_V2', { ..._filter, useRunTask: true }, hAll)),

      map(coll => {
        this.dataCollection = coll;
        return this.dss.createMongoStore(coll, undefined, { key: 'id' });
      }),

      switchMap(async store => {
        const _self = this;

        return new ArrayStore({
          key: 'id',
          data: await store.load(),

          onPush(changes: { type; data; key; index? }[]) {
            // const rowIdxs = uniq(changes.filter(({ data }) => data.__skipRepaint !== true).map(({ key }) => key)).map(
            //   key => _self.grid.instance.getRowIndexByKey(key),
            // );
            // if (rowIdxs.length > 0) _self.grid.instance.repaintRows(rowIdxs);

            changes.forEach(({ data }) => (data.__skipRepaint = undefined));
          },

          onUpdating(key: any, values: SVObject) {
            values.__skipRepaint = undefined;
          },
        });
      }),

      map(store => {
        this.tripDsoMap.clear();

        return {
          store,
          reshapeOnPush: true,
          map: (doc: SVObject) => {
            this.tripDsoMap.set(doc.id, doc._trips);

            doc.getNote = function () {
              const _self = this as SVObject;
              const notes = [];
              if (oc(_self).meta.skipEmployeeId()) notes.push('Skipped by driver');
              return notes.join('.\n');
            }.bind(doc);

            // region locked

            doc._tripIdLocked = function () {
              const _self = this as SVObject;
              return (
                oc(_self).meta.partValidated() ||
                oc(_self).meta.fullValidated() ||
                oc(_self)._trips([]).length === 0 ||
                oc(_self)._trip.__claim.__status() === 'Paid'
              );
            }.bind(doc);

            // doc._lockedPu = function () {
            //   const _self = this as SVObject;
            //   return _self._locked() && !!_self.pickupTime;
            // }.bind(doc);
            //
            // doc._lockedDo = function () {
            //   const _self = this as SVObject;
            //   return _self._locked() && !!_self.dropoffTime;
            // }.bind(doc);
            //
            // doc._lockedFull = function () {
            //   const _self = this as SVObject;
            //   return _self._lockedPu() && _self._lockedDo();
            // }.bind(doc);

            // endregion

            // doc._trip = oc(doc)._trip(doc._possibleTrip);
            [doc._trip, ...doc._trips].filter(identity).forEach(t => {
              set(t, '__claim.__status', oc(t).__claim.__status(null));
              set(t, '__miles', oc(t)['Trip Mileage']() || oc(t).miles());
            });

            //

            this.setIssueData(doc);

            return doc;
          },
          postProcess: (groupsOrItems: TDsItem<SVObject>[]) => {
            // const data = this.gridItemsFlat(groupsOrItems);
            return groupsOrItems;
          },
        } as DataSourceOptions;
      }),
    );
  }

  vehicleData(id) {
    const self = this;

    if (!id) {
      return of({});
    }

    if (!self.vehicleDsMap[id]) {
      self.vehicleDsMap[id] = {};
    }

    if (!self.vehicleDsMap[id].fullInstance) {
      const inst$ = this.dss.getApi<VehicleApi>(Vehicle).findById(id, {}, hAll);

      self.vehicleDsMap[id].fullInstance = inst$;
    }

    return self.vehicleDsMap[id].fullInstance;
  }

  driverData(id) {
    const self = this;

    if (!id) {
      return of({});
    }

    if (!self.driverDsMap[id]) {
      self.driverDsMap[id] = {};
    }

    if (!self.driverDsMap[id].fullInstance) {
      const inst$ = this.dss.getApi<EmployeeApi>(Employee).findById(
        id,
        {
          include: [{ person: { contact: ['addresses', 'phones', 'emails'] } }],
        },
        hAll,
      );

      self.driverDsMap[id].fullInstance = inst$;
    }

    return self.driverDsMap[id].fullInstance;
  }

  //endregion

  private get gridStore() {
    return oc(this.grid).instance() ? (this.grid.instance.getDataSource().store() as CustomStore) : undefined;
  }

  private get gridItems() {
    return oc(this.grid).instance() ? (this.grid.instance.getDataSource().items() as TDsItem<SVObject>[]) : undefined;
  }

  private gridItemsFlat(items?: TDsItem<SVObject>[]): SVObject[] {
    return oc(items)(this.gridItems)
      .map(itm =>
        itm.hasOwnProperty('key') && itm.hasOwnProperty('items')
          ? (this.gridItemsFlat((itm as any).items) as SVObject[])
          : (itm as SVObject),
      )
      .flat();
  }

  //

  private setMissingData(doc: SVObject) {
    const __missingData: Record<string, string> = omitBy(
      {
        consumerId: !doc.consumerId ? 'Missing Client' : undefined,
        employeeId: !doc.employeeId ? 'Missing Driver' : undefined,
        vehicleId: !doc.vehicleId ? 'Missing Vehicle' : undefined,

        arrivedTime: isEmpty(doc.arrivedTime) ? 'Missing Arrived Time' : undefined,
        pickupTime: isEmpty(doc.pickupTime) ? 'Missing PU Time' : undefined,
        dropoffTime: isEmpty(doc.dropoffTime) ? 'Missing DO Time' : undefined,

        imgFileId: isEmpty(doc.imgFileId) ? 'Missing Signature Image' : undefined,
        marker: isEmpty(doc.marker) ? 'Missing Direction Marker' : undefined,
      },
      isNil,
    );

    const __missingList = compact(Object.values(__missingData));

    doc.__missingData = __missingData;
    doc.__missingList = __missingList;

    return [
      {
        type: 'update',
        data: {
          __missingData,
          __missingList,
        },
        key: doc.id,
      },
    ];
  }

  private setIssueData(doc: SVObject) {
    const missingChanges = this.setMissingData(doc);

    const arrTime = oc(doc).arrivedTime() ? moment(oc(doc).arrivedTime(), 'HH:mm:ss') : null;
    const puTime = oc(doc).pickupTime() ? moment(oc(doc).pickupTime(), 'HH:mm:ss') : null;
    const doTime = oc(doc).dropoffTime() ? moment(oc(doc).dropoffTime(), 'HH:mm:ss') : null;
    const lgtcPu = oc(doc)._trip.pu_time() ? moment(oc(doc)._trip.pu_time(), 'HH:mm') : null;

    const tripLeg =
      oc(doc)._trip._broker(null) === 'MTM' ? (oc(doc)._trip._tripId('').endsWith('B') ? 'B' : 'A') : undefined;
    const tripTime = oc(doc)._trip._time(null) ? moment(oc(doc)._trip._time(null), 'HHmm') : null;

    const __issueData: SVObject['__issueData'] = [
      {
        field: ['consumer_mci', 'consumer_person_lastname', 'consumer_person_firstname'],
        issue: doc.consumer_status === 'INACTIVE' ? 'INACTIVE Client' : undefined,
      },
      {
        field: ['marker'],
        issue: doc.marker === DIRECTION_MARKERS.UNKNOWN ? 'Direction Marker is UNKNOWN' : undefined,
      },
      {
        field: ['pickupTime', 'dropoffTime'],
        issue:
          puTime && doTime && doTime.diff(puTime, 'minutes', true) < this.minPuDoDiff
            ? `DO and PU diff less than ${this.minPuDoDiff} min`
            : undefined,
      },
      {
        field: ['pickupTime', 'dropoffTime'],
        issue:
          puTime && doTime && doTime.diff(puTime, 'minutes', true) > this.maxPuDoDiff
            ? `DO and PU diff more than ${this.maxPuDoDiff} min`
            : undefined,
      },
      {
        field: ['pickupTime'],
        issue:
          puTime && lgtcPu && Math.abs(lgtcPu.diff(puTime, 'minutes', true)) > this.maxPuLgtcPuDiff
            ? `Broker PU (${oc(doc)._trip.pu_time()}) and Driver PU diff more than ${this.maxPuLgtcPuDiff} min`
            : undefined,
      },

      ...(isAlpha()
        ? [
            {
              field: ['dropoffTime'],
              severity: 'warning',
              issue:
                tripLeg === 'A' && doTime && doTime.diff(tripTime, 'minutes') < -30
                  ? `Broker DO [${tripTime.format('HH:mm')}] and Driver DO [${doTime.format('HH:mm')}] diff more than 30 min`
                  : undefined,
            },

            {
              field: ['dropoffTime'],
              severity: 'critical',
              issue:
                tripLeg === 'A' && doTime && doTime.diff(tripTime, 'minutes') > 5
                  ? `Broker DO [${tripTime.format('HH:mm')}] and Driver DO [${doTime.format('HH:mm')}] diff more than 5 min`
                  : undefined,
            },

            {
              field: ['pickupTime'],
              severity: 'warning',
              issue:
                tripLeg === 'B' && puTime && puTime.diff(tripTime, 'minutes') < -30
                  ? `Broker PU [${tripTime.format('HH:mm')}] and Driver PU [${puTime.format('HH:mm')}] diff more than 30 min`
                  : undefined,
            },

            {
              field: ['pickupTime'],
              severity: 'critical',
              issue:
                tripLeg === 'B' && puTime && puTime.diff(tripTime, 'minutes') > 5
                  ? `Broker PU [${tripTime.format('HH:mm')}] and Driver PU [${puTime.format('HH:mm')}] diff more than 5 min`
                  : undefined,
            },
          ]
        : []),
    ];

    return [...missingChanges, ...this.service.processIssueData(doc, __issueData)];
  }

  private storeUpdate$(entries: { key; values }[]) {
    return this.service.storeUpdate$(
      entries,
      async (key, values) => {
        const doc = this.gridItemsFlat().find(itm => itm.id === key);
        const issueChanges = this.setIssueData({ ...doc, ...values });
        for (const { data } of issueChanges) {
          for (const k of Object.keys(data)) values[k] = data[k];
        }
      },
      true,
    );
  }

  filter() {
    this.$filterEvent$.next(true);
  }

  getPrevTimes$(data: SVObject, tooltip: DxTooltipComponent) {
    if (!this.toolTipDataMap['timesPuDo:' + data.id]) {
      const fromIncl = utc(data.vdate).startOf('week');
      const toIncl = utc(data.vdate).endOf('week');
      const toExcl = toIncl.clone().add(1, 'day');

      this.toolTipDataMap['timesPuDo:' + data.id] = of(data).pipe(
        switchMap(e =>
          combineLatest([
            this.sapi.find<Signature>(
              {
                where: {
                  and: [
                    { tenantId: e.tenantId },
                    { consumerId: e.consumerId },
                    { vdate: { lt: e.vdate } },
                    { weekday: utc(e.vdate).isoWeekday() - 1 },
                    { type: e.type },
                    { marker: e.marker },
                    { validationState: { nin: ['INVALID', 'PENDING'] } },

                    { type: { nin: ['R', 'V', 'C'] } },
                    { or: [{ status: { nlike: 'X%' } }, { status: null }] },
                  ],
                },
                order: 'vdate DESC',
                limit: 1,
              },
              hAll,
            ),
            this.sapi.find<Signature>(
              {
                where: {
                  and: [
                    { vdate: { gte: fromIncl.format('YYYY-MM-DD') } },
                    { vdate: { lt: toExcl.format('YYYY-MM-DD') } },
                    { tenantId: e.tenantId },
                    { consumerId: e.consumerId },
                    { type: e.type },
                    { marker: e.marker },
                    { validationState: { nin: ['INVALID', 'PENDING'] } },

                    { type: { nin: ['R', 'V', 'C'] } },
                    { or: [{ status: { nlike: 'X%' } }, { status: null }] },
                  ],
                },
                order: 'vdate DESC',
                limit: 1,
              },
              hAll,
            ),
          ]),
        ),
        map(([signs1, signs2]) => [signs1[0], ...signs2]),
        map(
          signs =>
            '<table>' +
            [
              ['', ...compact(signs).map(s => utc(s.vdate).format('MM/DD ddd'))].map(i => `<td>${i}</td>`).join(''),
              ['arr', ...compact(signs).map(s => moment(s.arrivedTime, 'HH:mm:ss').format('HH:mm'))]
                .map(i => `<td>${i}</td>`)
                .join(''),
              ['pu', ...compact(signs).map(s => moment(s.pickupTime, 'HH:mm:ss').format('HH:mm'))]
                .map(i => `<td>${i}</td>`)
                .join(''),
              ['do', ...compact(signs).map(s => moment(s.dropoffTime, 'HH:mm:ss').format('HH:mm'))]
                .map(i => `<td>${i}</td>`)
                .join(''),
            ]
              .map(i => `<tr>${i}</tr>`)
              .join('') +
            '</table>',
        ),
        startWith('...'),
        catchError(err => of('')),
        tap(() => setTimeout(() => tooltip && tooltip.instance.repaint(), 10)),
      );
    }

    return this.toolTipDataMap['timesPuDo:' + data.id];
  }

  //

  from_onValueChanged(e) {
    // console.log(e);
    this.selectedToValue = moment(e.value).toDate();
  }

  facility_onSelectionChanged(e) {
    // console.log(e.selectedItem);

    this.consumerDso = this.service.buildConsumerDataSource(this.facilityId);
    this.employeeDso = this.service.buildEmployeeDataSource(this.facilityId);
    this.vehicleDso = this.service.buildVehicleDataSource();
  }

  tripId_selectedItemChange(cellInfo: { key; data: SVObject }, e) {
    // this runs on init grid to
    // console.log(cellInfo, e.selectedItem);
    // console.log('tripId_onSelectionChanged', oc(cellInfo).data._trip._tripId(), oc(e.selectedItem)._tripId());
    // runs on every initialization!!!
    // const newTrip = e.selectedItem;
    // this.$cmpAddresses$.next([{ key: cellInfo.key, tripId: oc(newTrip)._tripId() }]);
  }

  tripId_onValueChanged(cellInfo: { key; data: SVObject }, e) {
    // this not runs on init grid
    // console.log('tripId_onValueChanged', oc(cellInfo).data._trip._tripId(), oc(e).value());

    const newTripId = e.value;
    const newTrip = cellInfo.data._trips.find(t => t._tripId === newTripId);

    //
    void this.storeUpdate$([{ key: cellInfo.key, values: { _trip: oc(newTrip)(null) } }]).toPromise();
    // this.$cmpAddresses$.next([{ key: cellInfo.key, tripId: oc(newTrip)._tripId() }]);
    // this.grid.instance.repaintRows([cellInfo.rowIndex]);
  }

  //////////////////////////////////////////////////////

  grid_onInitialized(e) {
    this.service.init({ grid: this.grid });
    this.grid.instance.clearSelection();
  }

  grid_onDataErrorOccurred(e) {
    console.log(e);
  }

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent) {
    e.toolbarOptions.items.unshift(
      {
        // disabled: this.$showFromBroker$.value,
        name: 'selectAllValid',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'before',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-select',
          text: 'Select All Trustworthy Trips',
          hint: 'Select All Trustworthy Trips On This Page Only',
          onClick: this.grid_toolbar_selectAllValid_onClick.bind(this),
        },
      },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'setValidSelected',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'before',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-valid',
          text: 'Validate Selected Trips',
          hint: 'Validate Selected Trips',
          onClick: () =>
            void this.service
              .batchSignatureUpdate$(
                d => !['VALID'].includes(d.validationState),
                { validationState: 'VALID' },
                this.storeUpdate$.bind(this),
              )
              .toPromise(),
        },
      },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'setInvalidSelected',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'before',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-invalid',
          text: 'Invalidate Selected Trips',
          hint: 'Invalidate Selected Trips',
          onClick: () =>
            void this.service
              .batchSignatureUpdate$(
                d => !['INVALID'].includes(d.validationState),
                { validationState: 'INVALID' },
                this.storeUpdate$.bind(this),
              )
              .toPromise(),
        },
      },
      {
        name: 'refresh',
        locateInMenu: 'auto',
        location: 'after',
        sortIndex: 99,
        widget: 'dxButton',
        showText: 'inMenu',
        options: {
          icon: 'refresh',
          text: 'Refresh',
          hint: 'Refresh',
          onClick: () => e.component.refresh(),
        },
      },
    );
  }

  grid_onContextMenuPreparing(e: DxContextMenuPreparingEvent) {
    if (oc(e).row.rowType() === 'data' && !e.row.isEditing) {
      const doc: SVObject = e.row.data;
      const key = e.row.key;

      const confirmFn = () =>
        doc.meta.partValidated || doc.meta.fullValidated
          ? this.common.signedEmployee$.pipe(
              switchMap(signed =>
                confirm(
                  '<i>By Saving this record, ' +
                    `I ${oc(signed).person.firstname()} ${oc(signed).person.lastname()} ` +
                    `<br/>certify that provided information is verified and accurate, ` +
                    `<br/>and may be submitted for billing in current form.</i>`,
                  'Confirm changes',
                ),
              ),
            )
          : of(true);

      e.items = [
        {
          text: 'Change Signature Image',
          onItemClick: () => {
            void this.isBiller$
              .pipe(
                switchMap(async inRole => {
                  // if (!inRole) {
                  //   notify('Access denied for the user', 'warning', 5000);
                  // } else

                  if (false && doc._locked() && !isEmpty(doc.imgFileId)) {
                    notify('Service is locked', 'warning', 5000);
                  } else {
                    return this.dialog
                      .open<
                        any,
                        any,
                        {
                          data: SignatureConsUniqImgView;
                          toAllSignatures?: boolean;
                          toClient?: boolean;
                        }
                      >(DlgSelectSignatureComponent, {
                        hasBackdrop: true,
                        data: { signature: doc },
                      })
                      .afterClosed()
                      .pipe(
                        switchMap(v =>
                          iif(
                            () => !!oc(v).data(),
                            of(v).pipe(
                              map(() => ({ imgFileId: v.data.imgFileId })),
                              this.service.wrapLoadingCatchOperator(() =>
                                switchMap(values =>
                                  this.sapi
                                    .patchAttributes(doc.id, values, hAll)
                                    .pipe(mergeMap(() => this.storeUpdate$([{ key, values }]))),
                                ),
                              ),
                            ),
                          ),
                        ),
                      )
                      .toPromise();
                  }
                }),
              )
              .toPromise();
          },
        },
        {
          text: 'Change Arr/PU/DO Time',
          onItemClick: () => {
            // if (doc._locked()) {
            //   notify('Service is locked', 'warning', 5000);
            // } else
            void this.dialog
              .open(DlgEditTimesComponent, {
                hasBackdrop: true,
                data: { signature: doc, useFieldLock: false },
              })
              .afterClosed()
              .pipe(
                switchMap((v: { arrivedTime; pickupTime; dropoffTime }) =>
                  iif(
                    () => !!v,
                    defer(confirmFn).pipe(
                      filter(identity),
                      map(() => ({
                        // scheduledTime: v.scheduledTime ? moment(v.scheduledTime).format('HH:mm:ss') : null,
                        arrivedTime: v.arrivedTime ? moment(v.arrivedTime).format('HH:mm:ss') : null,
                        pickupTime: v.pickupTime ? moment(v.pickupTime).format('HH:mm:ss') : null,
                        dropoffTime: v.dropoffTime ? moment(v.dropoffTime).format('HH:mm:ss') : null,
                      })),
                      // tap((res) => console.log(res)),
                      this.service.wrapLoadingCatchOperator(() =>
                        switchMap(values =>
                          this.sapi
                            .patchAttributes(doc.id, values, hAll)
                            .pipe(mergeMap(() => this.storeUpdate$([{ key, values }]))),
                        ),
                      ),
                    ),
                  ),
                ),
              )
              .toPromise();
          },
        },
        {
          text: 'Change Vehicle',
          onItemClick: () => {
            if (false && doc._locked() && !isEmpty(doc.vehicleId)) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgSelectVehicleComponent, {
                  width: '450px',
                  maxHeight: '650px',
                  hasBackdrop: true,
                  data: {
                    recIds: [doc.vehicleId],
                    filter: {},
                  },
                })
                .afterClosed()
                .pipe(
                  filter(keys => keys !== false && keys && keys.length === 1),
                  map(keys => keys[0]),
                  this.service.wrapLoadingCatchOperator(() =>
                    switchMap(vId =>
                      this.sapi.patchAttributes(doc.id, { vehicleId: vId }, hAll).pipe(
                        mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                        mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                        tap(() => (this.vehicleSubDso$ = this.service.buildVehicleSubDataSource$())),
                      ),
                    ),
                  ),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Driver',
          onItemClick: () => {
            if (false && doc._locked() && !isEmpty(doc.employeeId)) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgSelectDriverComponent, {
                  width: '450px',
                  maxHeight: '650px',
                  hasBackdrop: true,
                  data: {
                    recIds: [doc.employeeId],
                    filter: {
                      or: [
                        { tenantId: doc.tenantId },
                        { tenantIds: { $json_e_c: { $: JSON.stringify(doc.tenantId) } } },
                      ],
                    },
                    skipTenantCheck: true,
                  },
                })
                .afterClosed()
                .pipe(
                  filter(keys => keys !== false && keys && keys.length === 1),
                  map(keys => keys[0]),
                  this.service.wrapLoadingCatchOperator(() =>
                    switchMap(eId =>
                      this.sapi.patchAttributes(doc.id, { employeeId: eId }, hAll).pipe(
                        mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                        mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                        tap(() => (this.employeeSubDso$ = this.service.buildEmployeeSubDataSource$())),
                      ),
                    ),
                  ),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Service Type / Marker',
          onItemClick: () => {
            if (false && doc._locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgEditServiceTypeComponent, {
                  hasBackdrop: true,
                  data: { signature: doc },
                })
                .afterClosed()
                .pipe(
                  switchMap(v =>
                    iif(
                      () => !!v,
                      of(v).pipe(
                        this.service.wrapLoadingCatchOperator(() =>
                          switchMap(({ serviceType, marker }) =>
                            this.sapi.updateServiceTypeAndMarker(doc.id, serviceType, marker, hAll).pipe(
                              // mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                              mergeMap(s => this.storeUpdate$([{ key, values: s }])),
                            ),
                          ),
                        ),
                      ),
                    ),
                  ),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Meals Units',
          onItemClick: () => {
            if (false && doc._locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgEditUnitsComponent, {
                  hasBackdrop: true,
                  data: { signature: doc },
                })
                .afterClosed()
                .pipe(
                  filter(v => !isEmpty(v)),
                  this.service.wrapLoadingCatchOperator(() =>
                    switchMap(o => {
                      o = pickBy(
                        mapKeys(
                          o,
                          (v, k) =>
                            ({
                              W1759: 'HOT',
                              W1760: 'FROZEN',
                              W1761: 'SANDWICH',
                              W1762: 'EMERGENCY',
                              W1764: 'SPECIAL',
                            })[k] || k,
                        ),
                        (v, k) => v > 0,
                      );

                      return this.sapi.patchAttributes(doc.id, { meta: { mealDroppedCountList: o } }, hAll).pipe(
                        mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                        mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                      );
                    }),
                  ),
                )
                .toPromise();
          },
        },
      ];
    }
  }

  grid_onCellPrepared(e: DxCellPreparedEvent<SVObject>) {
    // console.log(e);

    // if (e.rowType === 'header') {
    //   if (e.column.name && !this.toolTipVisible[e.column.name]) {
    //     this.toolTipVisible[e.column.name] = {};
    //     this.toolTipData[e.column.name] = {};
    //   }
    // }

    //

    if (e.rowType === 'data') {
      const _cleanUpClass = _e => {
        const cellClasses = [
          'cell-red',
          'cell-green',
          'cell-blue',
          'cell-yellow',
          'cell-orange',
          'cell-violet',
          'cell-trip-warning',
          'cell-trip-danger',
        ];

        _e.cellElement.classList.remove(...cellClasses);
        _e.cellElement.title = '';
      };
      _cleanUpClass(e);

      {
        const _missingFn = () => {
          e.cellElement.classList.remove('cell-missing-data');
          if (this.service.colInFields(Object.keys(e.data.__missingData), e.column)) {
            e.cellElement.classList.add('cell-missing-data');
          }
        };

        _missingFn();
        e.watch(() => e.data.__missingList, _missingFn);
      }

      {
        this.service.processIssuesForCell(e);
      }

      if (e.column.dataField === 'validationState') {
        function _validationStateFn() {
          e.cellElement.style.color = 'auto';

          switch (oc(e).data.validationState()) {
            case 'VALID': {
              e.cellElement.style.color = 'green';
              break;
            }
            case 'INVALID': {
              e.cellElement.style.color = 'red';
              break;
            }
            case 'ISSUES': {
              e.cellElement.style.color = 'darkorange';
              break;
            }
          }
        }
        _validationStateFn();
        e.watch(() => e.data.validationState, _validationStateFn);
      }

      {
        const _lockedFn = () => {
          e.cellElement.classList.remove('cell-locked');
          if (e.data.meta.partValidated || e.data.meta.fullValidated) {
            e.cellElement.classList.add('cell-locked');
          }
        };

        _lockedFn();
        e.watch(() => e.data.meta.partValidated, _lockedFn);
        e.watch(() => e.data.meta.fullValidated, _lockedFn);
      }
    }
  }

  grid_onCellClick(e: DxCellEvent<SVObject>) {
    if (e.rowType === 'data' && e.column.caption === 'Trip ID') {
      e.event.stopImmediatePropagation();
    }
  }

  grid_onSelectionChanged(e) {
    // console.log('grid_onSelectionChanged');
    // this.$cmpAddresses$.next(e.selectedRowKeys);
    // this.$cmpAddresses$.next(
    //   (e.currentSelectedRowKeys as number[])
    //     .map(key => [key, (e.selectedRowsData).find(data => data.id === key)])
    //     .map(([key, data]) => ({ key, tripId: oc(data)._trip._tripId() })),
    // );
  }

  grid_onSaving(e: DxSavingEvent) {
    // console.log('grid_onSaving:', e);
    // this.$changes$.next(e.changes);
    // this.grid.instance.repaint();

    e.cancel = true;
    e.promise = of(e)
      .pipe(
        map(({ changes }) => changes.filter(change => change.type === 'update')),
        filter(changes => changes.length > 0),
        this.service.wrapLoadingCatchOperator(() =>
          concatMap(changes =>
            from(changes).pipe(
              // if (
              //   (doc.meta.partValidated || doc.meta.fullValidated) &&
              //   'validationState' in change.data &&
              //   change.data.validationState !== 'VALID'
              // ) {
              //   throw new Error('Cannot update locked record');
              // }
              // map(change => ({ change, doc: this.gridItems.find(itm => itm.id === change.key) })),

              map(change =>
                this.sapi.patchAttributes(change.key, change.data, hAll).pipe(
                  // mergeMap(() => this.svapi.findById<SignatureView>(change.key, {}, hAll)),
                  mergeMap(s => this.storeUpdate$([{ key: change.key, values: s }])),
                  // tap(() => this.grid.instance.repaintRows([rowIdx])),
                ),
              ),
              concatAll(),
            ),
          ),
        ),
      )
      .toPromise()
      .then(() => {
        this.editRowKey = null;
        this.changes = [];
      });
  }

  grid_onSaved(e: DxSavedEvent) {
    // this.grid.instance.repaintRows(e.changes.map(({ key }) => this.grid.instance.getRowIndexByKey(key)));
  }

  //////////////////////////////////////////////////////

  showTooltip1(cellInfo: DxCellEvent<SVObject>) {
    this.currentTooltipTemplate = 'arrPuDoTimes';
    this.tooltipData = cellInfo.data;
    this.tooltipTargetSelector = cellInfo.cellElement;
    this.isTooltipVisible = true;
  }

  showTooltip2(cellInfo: DxCellEvent<SVObject>, trip: SVObject['_trip']) {
    this.currentTooltipTemplate = 'trips';
    this.tooltipData = { data: cellInfo.data, trip };
    this.tooltipTargetSelector = cellInfo.cellElement;
    this.isTooltipVisible = true;
  }

  showTooltip3(cellInfo: DxCellEvent<SVObject>) {
    this.currentTooltipTemplate = 'trip';
    this.tooltipData = cellInfo.data;
    this.tooltipTargetSelector = cellInfo.cellElement;
    this.isTooltipVisible = true;
  }

  showPopover1(cellInfo: DxCellEvent<SVObject>) {
    this.currentPopoverTemplate = 'mealImg';
    this.popoverData = cellInfo.value;
    this.popoverTargetSelector = cellInfo.cellElement;
    this.isPopoverVisible = true;
  }

  async grid_toolbar_selectAllValid_onClick() {
    this.grid.instance.clearSelection();
    await this.grid.instance.deselectAll();

    const keys = this.gridItemsFlat()
      .filter(doc => doc._valid === true && doc.validationState !== 'VALID')
      .filter(doc => doc.__issueList.length === 0)
      .map(doc => doc.id);

    await this.grid.instance.selectRows(keys, false);
  }
}
